import {Injectable} from '@angular/core';
import {MultiShareValidation} from './multi-share-validation.domain';

/**
 * How components interact via service:
 *    https://angular.io/guide/component-interaction#parent-and-children-communicate-using-a-service
 *
 * Shared service and `ExpressionChangedAfterItHasBeenCheckedError`:
 *    https://indepth.dev/posts/1001/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error#shared-service
 *
 */
@Injectable({
  providedIn: 'root'
})
export class MultiShareValidationService {

  validations: Map<string, MultiShareValidation> = new Map<string, MultiShareValidation>();

  readonly addValidationTimeout = 500;

  constructor() {
  }

  /**
   * This resets all existing validations.
   *
   * Reason: A `root` provided service may life longer than a component.
   */
  public init(): void {
    this.validations.clear();
  }

  public notifyValidate(validation: MultiShareValidation): void {
    // using a delay to prevent ExpressionChangedAfterItHasBeenCheckedError
    // when a child component fires this method on their init cycle.
    // see this class doc for more details
    setTimeout(() => this.validations.set(validation.key, validation), this.addValidationTimeout);
  }

  public isValid(): boolean {
    return Array.from(this.validations.values()).every((it) => it.valid);
  }

  public errorHints(): string[] {
    return Array.from(this.validations.values()).filter((it) => !it.valid).map((it) => it.hint) as string[];
  }
}
